import { BaseApi } from '@/main/baseApi';

import { MODULE_API, NAME } from './constants';
import { SmsRequestData } from './state';

class SMSProvider extends BaseApi {
	async sendSms(smsRequestData: SmsRequestData) {
		return this.post(`/${MODULE_API}/${NAME}/SendSMS`, smsRequestData);
	}
}
export const apiProvider = new SMSProvider(MODULE_API, NAME);
